<template>
  <app-layout>
    <span slot="toolbar-title">{{ $t('nav.quotes') }}</span>

    <template slot="header">
      <q-tabs inverted align="center" v-model="stage">
        <q-tab
          slot="title"
          :label="$t('quote_list.new')"
          name="new"
        />
        <q-tab
          slot="title"
          :label="$t('quote_list.in_progress')"
          name="in_progress"
        />
        <q-tab
          slot="title"
          :label="$t('quote_list.unassigned')"
          name="unassigned"
        />
      </q-tabs>

      <q-search
        class="q-pa-sm bg-white"
        v-model="search"
        hide-underline
        clearable
        :placeholder="$t('general.search')"
      />
    </template>

    <q-page padding>
      <q-infinite-scroll :handler="loadMore" ref="infiniteScroll">
        <q-list separator v-if="quotes.length">
          <q-item multiline v-for="quote in quotes" :key="quote.id" :to="`quotes/${quote.id}`">
            <q-item-main>
              <q-item-tile label lines="2">{{ quote.attributes.subject }}</q-item-tile>
              <q-item-tile sublabel>
                {{ quote.attributes.ship_street }}
              </q-item-tile>
              <q-item-tile sublabel>
                {{ quote.attributes.ship_zip_code + ' ' + quote.attributes.ship_city }}
              </q-item-tile>
            </q-item-main>
          </q-item>
        </q-list>
        <div v-if="(!quotes.length && !loading)" class="row col justify-center items-center">
          <h4>{{ $t('quote_list.no_quotes') }}</h4>
        </div>
        <template slot="message">
          <div class="row justify-center q-my-md">
            <q-spinner-dots color="primary" size="40px" />
          </div>
        </template>
      </q-infinite-scroll>
    </q-page>
  </app-layout>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      page: 0,
      quotes: [],
      loading: false
    }
  },
  computed: {
    stage: {
      get () {
        return this.$store.state.quotes.filter
      },
      set (value) {
        this.$store.dispatch('setQuoteFilter', value)
      }
    },
    search: {
      get () {
        return this.$store.state.quotes.search
      },
      set (value) {
        this.$store.dispatch('setQuoteSearch', value)
      }
    },
    stageFilter () {
      const filters = {
        unassigned: [
          { '$eq': ['stage', 'Created'] },
          {
            '$or': [
              { 'cf_tyon_suorittaja': null },
              { 'cf_tyon_suorittaja': 0 }
            ]
          }
        ],
        new: [
          { '$eq': ['stage', 'Created'] },
          { '$eq': ['cf_tyon_suorittaja', this.$store.state.auth.userId] }
        ],
        in_progress: [
          {
            '$or': [
              { 'stage': 'Reviewed' },
              { 'stage': 'Työ aloitettu' }
            ]
          },
          { '$eq': ['cf_tyon_suorittaja', this.$store.state.auth.userId] }
        ]
      }
      return filters[this.stage]
    },
    searchFilter () {
      return {
        '$or': [
          { '$cts': ['subject', this.search] },
          { '$cts': ['ship_street', this.search] },
          { '$cts': ['ship_zip_code', this.search] },
          { '$cts': ['ship_city', this.search] }
        ]
      }
    },
    filter () {
      return [...this.stageFilter, this.searchFilter]
    },
    userId () {
      return this.$store.state.auth.userId
    }
  },
  watch: {
    filter () {
      this.quotes = []
      this.$refs.infiniteScroll.reset()
      this.$refs.infiniteScroll.resume()
      this.$refs.infiniteScroll.loadMore()
    }
  },
  methods: {
    loadMore (index, done) {
      this.loading = true
      const filterJSON = JSON.stringify(this.filter)
      axios.get(`/quotes?page[size]=20&page[number]=${index}&filter=${filterJSON}&sort=-created_at&fields[quotes]=subject,ship_street,ship_city,ship_zip_code,stage,cf_tyon_suorittaja`)
        .then(res => {
          this.loading = false
          const data = res.data.data
          this.quotes.push(...data)
          if (!data.length) this.$refs.infiniteScroll.stop()
          done()
        })
    }
  },
  meta () {
    // Quasar meta plugin sets document title
    return {
      title: this.$t('nav.quotes')
    }
  }
}
</script>

<style scoped>
header .q-tabs {
  border-bottom: 1px solid #e0e0e0;
}
</style>
